import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const BODY_LIST_SCHEMA = Object.freeze({
  HIGHLIGHTED: false,
  MESSAGE: '',
  ICON_URL: '',
});
const RECORD = generateSchema(BODY_LIST_SCHEMA);
const KEYS: any = generateKeys(BODY_LIST_SCHEMA);

export class BodyList extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get highlighted(): boolean {
    return this.get(KEYS.HIGHLIGHTED);
  }

  get message(): string {
    return this.get(KEYS.MESSAGE);
  }

  get iconUrl(): string {
    return this.get(KEYS.ICON_URL);
  }
}
